import React, { useState, useEffect } from "react";
import { useBranding } from "../../../../branding/BrandingContextProvider";
import Select from "../../../../components/Select";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchAllIssueTypes,
  fetchServiceRequestTags,
} from "../../../../store/actions/formOptions";
import { FormHeader } from "../FormHeader";
import { selectItems } from "../../../../store/selectors/items";
import { fetchServicesProviderAndPropertyDeveloperList } from "../../../../store/actions/FilterServiceProviderandPropertyDeveloperList";
import { serviceProviderSelector } from "../../../../store/selectors/serviceProviders";
import Button from "../../../../components/Button";
import { fetchServiceRequestStats } from "../../../../store/actions/serviceRequestStats";
import Picker from "../../../../components/Picker";
import { selectProperties } from "../../../../store/selectors/properties";
import moment from "moment";
import { ServiceRequestStatsReport } from "./Report";

export const ServiceRequestStatsForm = () => {
  const { branding } = useBranding();
  const dispatch = useDispatch();

  const [
    {
      fromDate,
      toDate,
      tags,
      issueType,
      serviceProvider,
      assetType,
      propertyId,
    },
    setFormData,
  ] = useState({
    fromDate: undefined,
    toDate: new Date(),
    tags: undefined,
    issueType: undefined,
    serviceProvider: undefined,
    assetType: undefined,
    propertyId: undefined,
  });

  const handleInputChange = (val, key) => {
    setFormData((formData) => ({ ...formData, [key]: val }));
  };

  const serviceRequestTags = useSelector(
    (state) => state.formOptions.serviceRequestTags ?? []
  );

  const auth = useSelector((state) => state.auth);
  const properties = useSelector(selectProperties);
  const serviceProviders = useSelector(serviceProviderSelector);
  const issueTypes = useSelector((state) => state.formOptions.types ?? []);
  const assets = useSelector(selectItems);

  const generateData = () => {
    dispatch(
      fetchServiceRequestStats({
        from: fromDate ? moment(fromDate).format("YYYY-MM-DD") : undefined,
        to: moment(toDate).format("YYYY-MM-DD"),
        tags: tags,
        issueType: issueType,
        serviceProvider: serviceProvider,
        assetType: assetType,
        propertyId: propertyId,
      })
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    let loginUserId = auth.user.id;
    let role = auth.user.roles[0].role.name;
    dispatch(fetchServiceRequestTags());
    dispatch(fetchAllIssueTypes());
    dispatch(fetchServicesProviderAndPropertyDeveloperList(loginUserId, role));
  };

  return (
    <div>
      <h4>Select Report Dates</h4>

      <Picker
        label="From Date"
        placeholderText="Select Date"
        selected={fromDate}
        onChange={(date) => handleInputChange(date, "fromDate")}
      />

      <Picker
        label="To Date"
        placeholderText="Select Date"
        selected={toDate}
        onChange={(date) => handleInputChange(date, "toDate")}
      />

      <h4>Filter By:</h4>

      <FormHeader>Property</FormHeader>
      <Select
        placeholder="Select Property"
        closeMenuOnSelect={false}
        options={
          properties?.length > 0
            ? properties.map((property) => ({
                value: property.id,
                label: property.name,
              }))
            : []
        }
        value={propertyId}
        onChange={(e) => handleInputChange(e.target.value, "propertyId")}
      />

      <FormHeader>Issue Type</FormHeader>
      <Select
        placeholder="Select Issue Type"
        closeMenuOnSelect={false}
        options={
          issueTypes?.length > 0
            ? issueTypes.map((issue) => ({
                value: issue.id,
                label: issue.name,
              }))
            : []
        }
        value={issueType}
        onChange={(e) => handleInputChange(e.target.value, "issueType")}
      />
      <FormHeader>Asset Type</FormHeader>
      <Select
        placeholder="Select Asset Type"
        closeMenuOnSelect={false}
        options={
          assets?.length > 0
            ? assets.map((asset) => ({
                value: asset.id,
                label: asset.name,
              }))
            : []
        }
        value={assetType}
        onChange={(e) => handleInputChange(e.target.value, "assetType")}
      />
      <FormHeader>Service Provider</FormHeader>
      <Select
        placeholder="Select Service Provider"
        closeMenuOnSelect={false}
        options={serviceProviders}
        value={serviceProvider}
        onChange={(e) => handleInputChange(e.target.value, "serviceProvider")}
      />
      <FormHeader>Tag</FormHeader>
      <Select
        placeholder="Select Tag"
        closeMenuOnSelect={false}
        options={
          serviceRequestTags?.length > 0
            ? serviceRequestTags.map((tag) => ({
                value: tag.id,
                label: tag.name,
              }))
            : []
        }
        value={tags}
        onChange={(e) => handleInputChange(e.target.value, "tags")}
      />

      <Button
        color="teal"
        size="small"
        label="Generate Report"
        onClick={() => {
          generateData();
        }}
      />
    </div>
  );
};
